import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";
import { TextField } from "@mui/material";

import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import { ColorPicker } from "react-color-palette";
import "react-color-palette/css";

export default function Theme({user}) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  // Get Data from backend
  useEffect(() => {
    let docs = langs.map((item) => ({
      primary: {
        hex: "#0f0469",
        rgb: {
          r: 15.270668043154801,
          g: 4.232860863095247,
          b: 104.57656250000001,
          a: 1,
        },
        hsv: {
          h: 246.60000000000002,
          s: 95.95238095238095,
          v: 41.01041666666667,
          a: 1,
        },
      },
      secondary: {
        hex: "#0f0469",
        rgb: {
          r: 15.270668043154801,
          g: 4.232860863095247,
          b: 104.57656250000001,
          a: 1,
        },
        hsv: {
          h: 246.60000000000002,
          s: 95.95238095238095,
          v: 41.01041666666667,
          a: 1,
        },
      },
      font: "",
      language: item.attributes.language,
    }));
    setData(docs);
    let errorDocs = [];
    langs.map(() => {
      errorDocs.push({ error: false });
    });
    setErrors(errorDocs);

    async function getData() {
      await fetch(`${API}/theme`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.themeData || [];

        setData((prevData) => {
          return prevData.map((localItem) => {
            const apiItem = apiData.find(
              (apiItem) => apiItem.language === localItem.language
            );

            if (apiItem) {
              return {
                ...localItem,
                primary: apiItem.primary || localItem.primary,
                secondary: apiItem.secondary || localItem.secondary,
                font: apiItem.font || localItem.font,
              };
            } else {
              return localItem;
            }
          });
        });
        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const submitData = (item, index) => {
    fetch(`${API}/theme`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { themeData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  return (
    <TabContext value={value}>
      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>Theme Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs"
        >
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={
                      SERVER_DOMAIN + item.attributes.icon.data.attributes.url
                    }
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 20,
                    }}
                  >
                    <div style={{ display: "flex", width: "100%", gap: 20 }}>
                      <div style={{ width: "40%" }}>
                        <div style={{ width: "100%", marginBottom: 15 }}>
                          <ColorPicker
                            hideAlpha
                            height={120}
                            color={
                              data[index]?.primary || {
                                hex: "#0f0469",
                                rgb: {
                                  r: 15.270668043154801,
                                  g: 4.232860863095247,
                                  b: 104.57656250000001,
                                  a: 1,
                                },
                                hsv: {
                                  h: 246.60000000000002,
                                  s: 95.95238095238095,
                                  v: 41.01041666666667,
                                  a: 1,
                                },
                              }
                            }
                            onChange={(c) => {
                              setData([
                                ...data.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, primary: c };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                            }}
                            hideInput={["rgb", "hsv"]}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <h3>Primary Color </h3>
                          <div
                            style={{
                              backgroundColor: data[index]?.primary?.hex,
                              width: 40,
                              height: 40,
                              borderRadius: 40,
                            }}
                          ></div>
                        </div>
                      </div>
                      <div style={{ width: "40%" }}>
                        <div style={{ width: "100%", marginBottom: 15 }}>
                          <ColorPicker
                            hideAlpha
                            height={120}
                            color={
                              data[index]?.secondary || {
                                hex: "#0f0469",
                                rgb: {
                                  r: 15.270668043154801,
                                  g: 4.232860863095247,
                                  b: 104.57656250000001,
                                  a: 1,
                                },
                                hsv: {
                                  h: 246.60000000000002,
                                  s: 95.95238095238095,
                                  v: 41.01041666666667,
                                  a: 1,
                                },
                              }
                            }
                            onChange={(c) => {
                              setData([
                                ...data.map((item, idx) => {
                                  if (idx === index) {
                                    return { ...item, secondary: c };
                                  } else {
                                    return item;
                                  }
                                }),
                              ]);
                            }}
                            hideInput={["rgb", "hsv"]}
                          />
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <h3 style={{ marginLeft: 5 }}>Secondary Color </h3>
                          <div
                            style={{
                              backgroundColor: data[index]?.secondary?.hex,
                              width: 40,
                              height: 40,
                              borderRadius: 40,
                            }}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{ display: user.perms[5].edit ? null : "none" }}
                    className="submitBTN"
                    onClick={() => submitData(item, index)}
                  >
                    Save Changes
                  </div>
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
